"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBreakpoints = void 0;
exports.defaultBreakpoints = {
    xs: 0,
    sm: 600,
    md: 986,
    lg: 1281,
    xl: 1536,
};
//# sourceMappingURL=breakpoints.js.map